import scssDefinedBreakPointMap from './breakpoints.module.scss';

function getMedia(min, max) {
  let media;
  let minMedia;
  let maxMedia;

  if (min) {
    minMedia = `(min-width: ${min}px)`;
  }

  if (max) {
    maxMedia = `(max-width: ${max - 1}px)`;
  }
  if (min && max) {
    media = `${minMedia} and ${maxMedia}`;
  } else if (min) {
    media = minMedia;
  } else if (max) {
    media = maxMedia;
  }

  return media;
}

export const getMediaMap = () => {
  // get breakpoint names define from scss, like [samll, medium ...]
  const breakpointNames = Object.keys(scssDefinedBreakPointMap);
  // get breakpoint values and convert '1024px' to 1024, like [0, 600, 1024, 1440]
  const breakpointValues = Object.values(scssDefinedBreakPointMap).map((x) => parseInt(x.replace('px', '').trim(), 10));
  return breakpointNames.reduce((obj, name, index) => {
    if (index < breakpointNames.length - 1) { // not last item
      return { ...obj, [name]: getMedia(breakpointValues[index], breakpointValues[index + 1]) };
    }
    return { ...obj, [name]: getMedia(breakpointValues[index], 0) };
  }, {});
};

export default getMediaMap;
